import { Token } from '@/sagas/login';
import { Buffer } from 'buffer';
import Cookies from 'js-cookie';

const userRoles: { [key: string]: string; } = {
  ROLE_STUDENT_PAY: 'student',
  ROLE_STUDENT_B2B: 'student',
  ROLE_STUDENT_B2BC: 'student',
  ROLE_TEACHER_PAY: 'teacher',
  ROLE_B2B_ADMIN: 'b2bAdmin',
  ROLE_ADMIN: 'admin',
};

const getAccessToken = () => {
  const token: string | undefined = Cookies.get('accessToken');

  return token || '';
};

const getRefreshToken = () => Cookies.get('refreshToken') || '';

const findRole = (roles: string[]) => {
  let role: string = '';

  roles.forEach((el: string) => {
    if (el === 'ROLE_B2B_ADMIN') {
      role = userRoles[el];
    }

    if (el === 'ROLE_ADMIN') {
      role = userRoles[el];
    }

    if (!role) role = userRoles[el];
  });

  return role;
};

const convertToken = (token: string) => {
  const base64Url = token.split('.')[1];

  if (base64Url) {
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    const decoded = JSON.parse(Buffer.from(base64, 'base64').toString('utf8'));

    return decoded;
  }

  return {};
};

const parseToken = (token: string) => {
  const decoded = convertToken(token);

  return {
    role: decoded.roles ? findRole(decoded.roles) : '',
    uid: decoded.uid,
  };
};

const getUserRole = () => {
  const token = getAccessToken();
  const roles = convertToken(token).roles || [];

  let payRole = 'no-role';
  let simpleRole = '';
  let roleType = '';

  roles.forEach((el: string) => {
    switch (el) {
      case 'ROLE_STUDENT_PAY':
        payRole = 'ed-student';
        simpleRole = 'student';
        roleType = 'ed';
        break;
      case 'ROLE_STUDENT_B2B':
        payRole = 'ed-student-b2b';
        simpleRole = 'student';
        roleType = 'ed';
        break;
      case 'ROLE_STUDENT_B2BC':
        payRole = 'ed-student-b2bc';
        simpleRole = 'student';
        roleType = 'ed';
        break;
      case 'ROLE_TEACHER_PAY':
        payRole = 'ed-teacher';
        simpleRole = 'teacher';
        roleType = 'ed';
        break;
      case 'ROLE_B2B_ADMIN':
        payRole = 'ed-admin-b2b';
        simpleRole = 'admin';
        roleType = 'ed';
        break;
      case 'ROLE_ADMIN':
        payRole = 'ed-admin';
        simpleRole = 'admin';
        roleType = 'ed';
        break;
      default:
        break;
    }
  });

  return {
    payRole,
    simpleRole,
    roleType,
  };
};

const saveToken = (data: Token) => {
  Cookies.set('accessToken', data.access_token, {
    path: '/',
  });
  Cookies.set('refreshToken', data.refresh_token, {
    path: '/',
  });
};

const deleteToken = (toRemoveRefresh: boolean) => {
  Cookies.remove('accessToken', { path: '/' });

  if (toRemoveRefresh) Cookies.remove('refreshToken', { path: '/' });
};

export default {
  getAccessToken,
  getRefreshToken,
  findRole,
  saveToken,
  parseToken,
  convertToken,
  deleteToken,
  getUserRole,
};
